import React from 'react';
import PageMenu from './PageMenu';

function MenuAbout(props) {
  return (
    <PageMenu
      {...props}
      title="About Menu"
      items={[
        {
          name: 'community-overview',
          title: 'Community Overview',
        },
        {
          name: 'amenities',
          title: 'Amenities',
        },
        {
          name: 'about-the-area',
          title: 'About The Area',
        },
        {
          name: 'map-and-directions',
          title: 'Map & Directions',
        },
        // {
        //   name: 'testimonials',
        //   title: 'Testimonials',
        // },
      ]}
    />
  );
}

export default MenuAbout;



// WEBPACK FOOTER //
// ./src/components/MenuAbout.js